export default __webpack_public_path__ + "static/media/info-icon.49896dab.svg";